// Creating a list to get the driver colours for each index from the initials list
export const DriverColours = {
    0: 'blue',
    1: 'blue',
    2: 'red',
    3: 'red',
    4: 'teal',
    5: 'teal',
    6: 'orange',
    7: 'orange',
    8: 'blue',
    9: 'blue',
    10: 'darkgray',
    11: 'darkgray',
    12: 'lightblue',
    13: 'lightblue',
    14: 'lime',
    15: 'lime',
    16: 'green',
    17: 'green',
    18: 'navy',
    19: 'navy'
}

// Creating a list of the 2025 driver initials
export const DriversInitials = [
    'VER',
    'TSU',
    'HAM',
    'LEC',
    'RUS',
    'ANT',
    'PIA',
    'NOR',
    'ALB',
    'SAI',
    'BEA',
    'OCO',
    'GAS',
    'DOO',
    'HUL',
    'BOR',
    'ALO',
    'STR',
    'LAW',
    'HAD'
]

// A list to define the drivers that the user is wanting to compare
export const HighlightedDrivers = []

export default DriverColours; 